<template>
    <div align="center" class="ma-2">
        <v-row no-gutters>
            <v-col v-for="{ part, object } of parts" :key="part">
                <v-btn :href="partLink(object)" target="_blank" color="secondary" class="mr-1">{{ part }}</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'PartNumbers',
    props: {
        apiBase: String,
        parts: Array,
    },
    methods: {
        partLink(object) {
            const url = new URL(`/part/${object}`, this.apiBase)
            return url.toString()
        },
    },
}
</script>
